import React from "react";
import ReactCalendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { CalendarProps, CalendarTileArgs } from "../../../types";
import "./Calendar.css";

const ChevronLeft: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 18l-6-6 6-6" />
  </svg>
);

const ChevronRight: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 18l6-6-6-6" />
  </svg>
);

const DoubleChevronLeft: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 17l-5-5 5-5M18 17l-5-5 5-5" />
  </svg>
);

const DoubleChevronRight: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M13 17l5-5-5-5M6 17l5-5-5-5" />
  </svg>
);

const Calendar: React.FC<CalendarProps> = ({
  value,
  onChange,
  minDate,
  maxDate,
  disabledDates = [],
  tileDisabled,
  selectRange = false,
  className = "",
  style,
  showNavigation = true,
  view,
  onViewChange,
  tileContent,
  ...props
}) => {
  // Combine custom tileDisabled logic with disabledDates array prop
  const handleTileDisabled = (args: CalendarTileArgs): boolean => {
    const { date, view: currentView } = args;

    if (typeof tileDisabled === "function" && tileDisabled(args)) {
      return true;
    }

    if (currentView === "month" && Array.isArray(disabledDates) && disabledDates.length > 0) {
      return disabledDates.some((disabledDate) => {
        const d = new Date(disabledDate);
        return (
          d.getFullYear() === date.getFullYear() &&
          d.getMonth() === date.getMonth() &&
          d.getDate() === date.getDate()
        );
      });
    }

    return false;
  };

  return (
    <div className={`custom-calendar-container ${className}`} style={style}>
      <ReactCalendar
        value={value}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        tileDisabled={handleTileDisabled}
        selectRange={selectRange}
        showNavigation={showNavigation}
        prevLabel={<ChevronLeft />}
        nextLabel={<ChevronRight />}
        prev2Label={<DoubleChevronLeft />}
        next2Label={<DoubleChevronRight />}
        view={view}
        onViewChange={onViewChange}
        tileContent={tileContent}
        {...props}
      />
    </div>
  );
};

export default Calendar;
